'use client';

import { GETv1SponsorsList } from '@/api/fund';
import { Section } from '@/components/atoms/Section';
import Card, { type SponsorCard } from '@/components/molecules/Sponsor/Card';
import { PUBLIC } from '@/constants/image/path';
import useFixedCard from '@/store/useFixedCard';
import { useQuery } from '@tanstack/react-query';
import Image from 'next/image';
import { ReactElement } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import '@/styles/pagination.css';

const SETTING = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  appendDots: (dots: ReactElement[]) => (
    <div className='bottom-0'>
      <ul className='mb-0 h-[10px]'>{dots}</ul>
    </div>
  ),
  customPaging: () => <div className='h-[3px] w-4 rounded-[1.5px] bg-[#b3c0ce]' />
};

function splitArray<T>(array: T[], part: number) {
  if (!array) return [];

  const res = [];
  for (let i = 0; i < array?.length; i += part) {
    res.push(array.slice(i, i + part));
  }
  return res;
}

const OrderCard = () => {
  const { clearFixedCard } = useFixedCard();
  const onClick = () => clearFixedCard();

  const { data } = useQuery({
    queryKey: ['order-card-sponsor'],
    queryFn: GETv1SponsorsList,
    select: res => res?.items.data
  });

  const pageData = splitArray<SponsorCard>(data, 2);

  return (
    <div className='h-full rounded-t-2xl bg-white pt-6'>
      <Section
        title='優質模擬交易平台'
        rightContent={
          <button className='mr-4' onClick={onClick}>
            <Image src={`${PUBLIC}/icons/close/close-modal.svg`} alt='close-icon' width={28} height={28} />
          </button>
        }
      />
      <div className='px-3'>
        <Slider {...SETTING}>
          {pageData?.map((page, i) => (
            <div key={`page-${i}`}>
              <div className='flex gap-3 pt-4'>
                <Card key={page[0]?.vendorId} {...page[0]} />
                <Card key={page[1]?.vendorId} {...page[1]} />
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default OrderCard;
